import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import FindModuleById from "../FindModuleById";
import { MaterialReactTable } from "material-react-table";
import { IconButton, Tooltip, MenuItem } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useQuery, keepPreviousData } from "@tanstack/react-query";
import axios from "axios";
import { Apitoken, Authtoken, base_url } from "../Global";
import PropTypes from 'prop-types';
import Swal from 'sweetalert2';


const SupplychainPackagelistHeaders = () => {
  const [menu, setMenu] = useState(false);
  const [permission, setPermission] = useState({});
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);

    let season_id = localStorage.getItem("season_id");

  const [pagination, setPagination] = useState({
    pageIndex: 0, // 0-based index for React Table
    pageSize: 10, // Default rows per page
  });

  useEffect(() => {
    const modulePermission = FindModuleById(91);
    setPermission(modulePermission);
  }, []);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  // Fetch Data using React Query
  const {
    data: queryData,
    isError,
    isRefetching,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: [
      "api/supply-chain-packaging-list-header/listing2",
      pagination.pageIndex,
      pagination.pageSize,
      season_id,
      columnFilters,
      globalFilter,
      sorting,
    ],
    queryFn: async () => {
      try {
        console.log("Fetching with pagination:", {
          page: pagination.pageIndex + 1,
          pageSize: pagination.pageSize,
        });
        
        const response = await axios.post(
          `${base_url}/supply-chain-packaging-list-header/listing2`,
          {
            filters: columnFilters,
            season_id: season_id,
            search: globalFilter,
            page: pagination.pageIndex + 1, // API expects 1-based indexing
            pageSize: pagination.pageSize,
            sorting: sorting.map(({ id, desc }) => ({
              column: id,
              order: desc ? "desc" : "asc",
            })),
          },
          {
            headers: {
              Authorization: `Bearer ${Authtoken}`,
              Apitoken: Apitoken,
            },
          }
        );

        console.log("API Response:", response.data);

        if (response.data.code === 200) {
          return {
            data: Array.isArray(response.data.data?.supply_chain_headers)
              ? response.data.data.supply_chain_headers
              : [],
            meta: { 
              totalRowCount: response.data.data?.totalRowCount || 0,
              pageCount: Math.ceil((response.data.data?.totalRowCount || 0) / pagination.pageSize)
            },
          };
        } else {
          throw new Error("Failed to fetch data");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        return { 
          data: [], 
          meta: { 
            totalRowCount: 0,
            pageCount: 0
          } 
        };
      }
    },
    placeholderData: keepPreviousData,
  });

  const tableData = queryData?.data || [];
  const totalRowCount = queryData?.meta?.totalRowCount || 0;
  const pageCount = queryData?.meta?.pageCount || 0;

  useEffect(() => {
    console.log("Table Data:", tableData);
    console.log("Current Pagination:", pagination);
    console.log("Total Pages:", pageCount);
    console.log("Total Rows:", totalRowCount);
  }, [tableData, pagination, pageCount, totalRowCount]);


  
  
  const LotNumberCell = ({ renderedCellValue, row }) => {
    return (
      <a href={`/supplychain-package-lists-view/${row.original.id}`} className="">
        {renderedCellValue}
      </a>
    );
  };
  
  // ✅ Define PropTypes validation
  LotNumberCell.propTypes = {
    renderedCellValue: PropTypes.string.isRequired,
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.number.isRequired,
      }).isRequired,
    }).isRequired,
  };
  // Define table columns
  const columns = useMemo(
    () => [
      
      {
        header: 'Lot Number',  
        accessorKey: 'lot_number',
        Cell: LotNumberCell,
      },
      {
        accessorKey: 'expedition_date',
        header: 'Expedition Date',
      },
      {
        header: 'Order',
        accessorFn: (row) => row.order_detail?.po_number || '',
      },
      {
        header: 'Production Type',
        accessorFn: (row) => row.productiontype?.title || '',
      },
      {
        accessorKey: 'truck_number',
        header: 'Truck Number',
      },
      {
        accessorKey: 'seal_number',
        header: 'Seal Number',
      },
      {
        header: 'Transport Company',
        accessorFn: (row) => row.transport_supplier?.name || '',
      },
      {
        accessorKey: 'dat_of_loading',
        header: 'Date Of Loading',
      },
      {
        accessorKey: 'total_net_weight',
        header: 'Total Net Weight',
      },
      {
        accessorKey: 'total_brut_weight',
        header: 'Total Brut Weight',
      },
      {
        header: 'Created By',
        accessorFn: (row) => row.createdby ? `${row.createdby.first_name} ${row.createdby.last_name}` : '',
      },
      {
        header: 'Updated By',
        accessorFn: (row) => row.updatedby ? `${row.updatedby.first_name} ${row.updatedby.last_name}` : '',
      },
    ],
    []
  );

  const deleteItem = (item) => {
    Swal.fire({
      title: 'Do you really want to delete this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`${base_url}/supply-chain-packaging-list-header/delete/${season_id+'-'+item}`, {
              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
            })
            .then((response) => {
              console.log(response);
              if (response.data.code === 200) {
                Swal.fire(
                  'Deleted!',
                  'Your Record has been deleted.',
                  'success'
                );
                setTimeout(() => {
                  window.location.href = "/supplychain-package-lists";
                }, 500);
              }
            })
            .catch((error) => {
              console.log(error);
            });
      }
    });
  }
 

  const editItem = (item)=>{
    window.location.href = "/supplychain-package-lists-edit/"+item;
  }
  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={toggleMobileMenu} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title"> Packing List</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">
                     Packing List
                  </li>
                </ul>
              </div>
              <div className="col-auto">
                {permission?.add == 1 && (
                  <Link
                    to="/supplychain-package-lists-add"
                    className="btn btn-primary me-1"
                  >
                    <i className="fas fa-plus"></i>
                  </Link>
                )}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  <div className="table-responsive">
                    {permission?.list == 1 ? (
                      <MaterialReactTable
                        columns={columns}
                        data={tableData}
                        manualFiltering
                        manualPagination
                        manualSorting
                        muiToolbarAlertBannerProps={
                          isError
                            ? { color: "error", children: "Error loading data" }
                            : undefined
                        }
                        onColumnFiltersChange={setColumnFilters}
                        onGlobalFilterChange={setGlobalFilter}
                        onSortingChange={setSorting}
                        onPaginationChange={setPagination}
                        renderTopToolbarCustomActions={() => (
                          <Tooltip arrow title="Refresh Data">
                            <IconButton onClick={() => refetch()}>
                              <RefreshIcon />
                            </IconButton>
                          </Tooltip>
                        )}
                        rowCount={totalRowCount}
                        pageCount={pageCount}
                        enableDebug={true}
                        state={{
                          columnFilters,
                          globalFilter,
                          isLoading,
                          pagination,
                          showAlertBanner: isError,
                          showProgressBars: isRefetching,
                          sorting,
                        }}
                        enableRowActions
                      //renderColumnActionsMenuItems 
                      renderRowActionMenuItems={({ row }) => [
                          permission?.update == 1 && (
                            <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                              Edit
                            </MenuItem>
                          ),
                          permission?.delete == 1 && (
                            <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                              Delete
                            </MenuItem>
                          ),
                        ]}
                      />
                    ) : (
                      <p>No permission to view data</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupplychainPackagelistHeaders;